import { FC } from 'react';
import { P, Span } from 'atoms/Typography';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useRouter } from 'modules/next/hooks';
import { Rating } from '../index';
import { RatingInfoProps } from '../types';
import styles from './RatingInfo.module.css';

export const RatingInfo: FC<RatingInfoProps> = ({ count, ranks, url }) => {
  const t = useTranslations();
  const { push } = useRouter();

  const handleClick = () => {
    if (url) {
      push(url);
    }
  };

  return (
    <>
      <P className={styles.title} onClick={handleClick}>
        {t('product.pdp.reviews.review-info-title', {
          count,
        })}
      </P>
      {ranks
        .sort((a, b) => b.rank - a.rank)
        .map(({ rank, amount }) => (
          <Span key={rank} className={styles.rating}>
            <Rating value={rank} size="medium" emptyIconType="filled" />
            {amount}
          </Span>
        ))}
    </>
  );
};
